<template>
  <div class="container-fluid content">
    <div class="alert alert-info">
      <van-notice-bar mode="closeable">
        <span class="notice-li">1,签名后的ipa文件在查看任务中，可直接下载</span>
        <span class="notice-li">2,签名后的ipa文件可直接上传至分发平台，进行安装内测</span>
        <span class="notice-li">3,ipa闪退等问题请直接联系客服进行人工操作</span>
        <span class="notice-li">4,代理及大公司业务请联系客服进行处理</span>
        <span class="notice-li">1,签名后的ipa文件在查看任务中，可直接下载</span>
        <span class="notice-li">2,签名后的ipa文件可直接上传至分发平台，进行安装内测</span>
        <span class="notice-li">3,ipa闪退等问题请直接联系客服进行人工操作</span>
        <span class="notice-li">4,代理及大公司业务请联系客服进行处理</span>
      </van-notice-bar>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-default">
          <tr>
            <th scope="col">序号</th>
            <!-- <th scope="col">套餐信息</th> -->
            <th scope="col">bundle id</th>
            <th scope="col">应用名</th>
            <th scope="col">剩余更新次数</th>
            <!-- <th scope="col">过期时间</th> -->
            <th scope="col">创建时间</th>
            <th scope="col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(autoSignApp,index) in autoSignApps">
            <th scope="row">{{index+1}}</th>
            <!-- <td>{{autoSignApp.mealDesc}}</td> -->
            <td>{{autoSignApp.bundleId}}</td>
            <td>{{autoSignApp.displayName}}</td>
            <td>{{autoSignApp.freeUpdateNum}}</td>
            <!-- <td>{{autoSignApp.expireTime | formatDateTime}}</td> -->
            <td>{{autoSignApp.createTime | formatDateTime}}</td>
            <td class>
              <button
                v-if="autoSignApp.freeUpdateNum>0 && Date.parse(new Date()) < autoSignApp.expireTime && autoSignApp.appStatus==1"
                @click="update(autoSignApp.id)" class="btn btn-warning">更新</button>
              <button v-if="autoSignApp.buqianStatus==1" @click="buqian(autoSignApp.id)"
                class="btn btn-warning">补签</button>
              <!-- <button
                v-if="autoSignApp.appStatus==0"
                @click="buyAgain(autoSignApp.id)"
                class="btn btn-warning"
              >重新支付</button>
              <button
                v-if="autoSignApp.appStatus==1"
                @click="buyUpdateNum(autoSignApp.id)"
                class="btn btn-success"
              >购买更新次数</button>
              <button
                v-if="autoSignApp.appStatus==1"
                @click="delay(autoSignApp.id,autoSignApp.mealId)"
                class="btn btn-success"
              >续费</button> -->
              <button @click="showTaskList(autoSignApp.id)" class="btn btn-primary">下载签名包</button>
              <button @click="del(autoSignApp.id,index)" class="btn btn-danger">删除</button>
            </td>
          </tr>
        </tbody>
      </table>

      <el-dialog title="应用签名列表" :visible.sync="autoSignAppTaskDialog" width="60%">
        <el-table :data="taskList">
          <el-table-column prop="taskNum" label="任务编号">
          </el-table-column>
          <el-table-column prop="taskStatus" :formatter="taskStatusFormate" label="任务状态">
          </el-table-column>
          <el-table-column label="原始IPA包">
            <template slot-scope="scope">
              <a :href="taskList[scope.$index].downloadUrl">{{taskList[scope.$index].downloadUrl}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :formatter="vueFormatDateTime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作	">
            <template slot-scope="scope">
              <el-button round type="success" @click="syncFenfa(taskList[scope.$index].taskNum)">同步分发</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <autoSignAppUpdateWindow v-if="showUpdateWindow" v-on:showModal="showModal" :autoSignAppId="autoSignAppId">
      </autoSignAppUpdateWindow>
      <autoSignPayWindow v-if="open_pay_window" :pay_link="payLink" v-on:showModal="showPayWindow"></autoSignPayWindow>
      <autoSignDelayWindow v-if="open_delay_window" :mealId="mealId" :autoSignAppId="autoSignAppId"
        v-on:showAutoSignDelayModal="showAutoSignDelayModal" />
    </div>

    <BuyAutoSignUpdateNum v-if="showBuyAutoSignUpdateNum" :autoSignAppId="autoSignAppId"
      v-on:closeBuyAutoSignUpdateNum="closeBuyAutoSignUpdateNum" />
    <AutoSignOrderDetail v-if="showAutoSignOrderDetail" :autoSignOrder="autoSignOrder"
      v-on:closeAutoSignOrderDetail="closeAutoSignOrderDetail" />
    <AutoSignAgainOrderDetail v-if="showAutoSignAgainOrderDetail" :autoSignOrder="autoSignOrder"
      v-on:closeAutoSignAgainOrderDetail="closeAutoSignAgainOrderDetail" />
    <fenfaSync v-if="fenfaSync" :fenfaSyncTaskNum="fenfaSyncTaskNum" v-on:closeFenfaSyncWindow="closeFenfaSyncWindow" />
  </div>
</template>

<script>
var self;
import autoSignAppUpdateWindow from "./AutoSignAppUpdateWindow";
import autoSignPayWindow from "./AutoSignPayWindow";
import autoSignDelayWindow from "./AutoSignDelayWindow";
import BuyAutoSignUpdateNum from "./BuyAutoSignUpdateNum";
import AutoSignOrderDetail from "./AutoSignOrderDetail";
import AutoSignAgainOrderDetail from "./AutoSignAgainOrderDetail";
import fenfaSync from "./FenfaSync";

export default {
  components: {
    autoSignAppUpdateWindow,
    autoSignPayWindow,
    autoSignDelayWindow,
    BuyAutoSignUpdateNum,
    AutoSignOrderDetail,
    AutoSignAgainOrderDetail,
    fenfaSync
  },
  mounted() {
    self = this;
    this.getMyAutoSignRecord();
  },
  data() {
    return {
      autoSignApps: [],
      autoSignAppId: 0,
      mealId: 0,
      showUpdateWindow: false,
      autoSignAppTaskDialog: false,
      open_pay_window: false,
      open_delay_window: false,
      payLink: "",
      show: false,
      showBuyAutoSignUpdateNum: false,
      autoSignOrder: null,
      showAutoSignOrderDetail: false,
      autoSignOrder: null,
      showAutoSignAgainOrderDetail: false,
      fenfaSync: false,
      fenfaSyncTaskNum: "",
      taskList: []
    };
  },
  methods: {
    getMyAutoSignRecord: function() {
      var token = this.getToken();
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/auto/sign/list", {
          authToken: token
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            self.autoSignApps = data;
          });
        });
    },
    update: function(autoSignAppId) {
      this.autoSignAppId = autoSignAppId;
      this.showUpdateWindow = true;
    },
    showModal: function(open_modal) {
      this.showUpdateWindow = open_modal;
    },
    showTaskList(autoSignAppId) {
      this.autoSignAppTaskDialog = true;
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/auto/sign/task/list", {
          authToken: this.getToken(),
          autoSignAppId: autoSignAppId
        })
        .then(response => {
          this.respDataHandle(response.body, data => {
            this.taskList = data;
            for (let task of data) {
              console.log("tag", task.taskNum);
            }
          });
        });
    },
    taskModal: function(open_modal) {
      this.showTaskWindow = open_modal;
    },
    showPayWindow: function() {
      this.open_pay_window = false;
    },
    buyUpdateNum: function(autoSignAppId) {
      this.autoSignAppId = autoSignAppId;
      this.showBuyAutoSignUpdateNum = true;
    },
    delay: function(autoSignAppId, mealId) {
      this.autoSignAppId = autoSignAppId;
      this.mealId = mealId;
      this.open_delay_window = true;
    },
    showAutoSignDelayModal: function(flag) {
      this.open_delay_window = flag;
    },
    del: function(autoSignAppId, index) {
      this.$confirm("此操作将永久删除数据无法恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post(
              this._Global.HTTP_SERVER +
                "/auth/auto/sign/app/del/" +
                autoSignAppId,
              { authToken: self.getToken() }
            )
            .then(response => {
              this.respDataHandle(response.body, data => {
                if (data == true) {
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                  this.autoSignApps.splice(index, 1);
                }
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    buyAgain: function(autoSignAppId) {
      var index = window.layer.msg("正在生成订单，请稍后", {
        time: 9999999
      });
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/order/autoSign/again", {
          authToken: this.getToken(),
          autoSignAppId: autoSignAppId
        })
        .then(response => {
          self.respDataHandle(
            response.body,
            function(data) {
              window.layer.close(index);
              self.autoSignOrder = data;
              self.showAutoSignAgainOrderDetail = true;
            },
            function() {
              window.layer.close(index);
            }
          );
        });
    },
    closeBuyAutoSignUpdateNum: function() {
      this.showBuyAutoSignUpdateNum = false;
    },
    closeAutoSignOrderDetail: function() {
      this.showAutoSignOrderDetail = false;
    },
    closeAutoSignAgainOrderDetail: function() {
      this.showAutoSignAgainOrderDetail = false;
    },
    buqian: function(autoSignAppId) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/auto/sign/app/buqian", {
          authToken: this.getToken(),
          autoSignAppId: autoSignAppId
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            if (data == true) {
              window.layer.msg("操作成功，正在补签");
            } else {
              window.layer.msg("补签操作失败");
            }
          });
        });
    },
    fenfaSyncWindow: function(taskNum) {
      this.fenfaSyncTaskNum = taskNum;
      this.fenfaSync = true;
    },
    closeFenfaSyncWindow: function() {
      this.fenfaSync = false;
    },
    taskStatusFormate: (row, column, cellValue) => {
      var context = "";
      switch (cellValue) {
        case 0:
          context = "等待签名";
          break;
        case 1:
          context = "签名完成";
          break;
        case 2:
          context = "更新签名";
          break;
        case 3:
          context = "等待补签";
          break;
        case 4:
          context = "补签成功";
          break;
      }
      return context;
    },
    syncFenfa: function(taskNum) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/sync/fromTaskNum", {
          taskNum: taskNum,
          authToken: this.getToken
        })
        .then(response => {
          this.respDataHandle(response.body, data => {
            if (data) {
              this.fenfaSyncWindow(taskNum);
              this.autoSignAppTaskDialog = false;
            }
          });
        });
    }
  }
};
</script>
<style scoped>
h2 {
  padding-top: 3em;
}
.table {
  text-align: center;
  margin-bottom: 0;
}
.alert-info {
  padding: 0;
  border-radius: 0;
  border: 0;
  background-color: transparent;
}
.alert-info .van-notice-bar {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.notice-li {
  display: inline-block;
  padding: 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/AutoSignManager.vue